import type { VAxios } from '../../define/axios/Axios';
import { PageRes } from '../../entities/cc/marketing.entities';

export const createApi = (defHttp: VAxios) => ({
  // 获取邀请码
  getInviteCode: () => {
    return defHttp.get({
      url: '/aiad/marketing/invite-code',
    });
  },

  // 邀请记录
  page: (params: { page: number; pageSize: number; sortField: string; sortOrder: string }) => {
    return defHttp.get<PageRes>({
      url: '/aiad/marketing/invite-log',
      params,
    });
  },

  // 邀请统计
  stat: () => {
    return defHttp.get<{ amount: number; person: number }>({
      url: '/aiad/marketing/invite-log-stat',
    });
  },
});
